import {fontStyles, theme} from '@styles/theme';
import styled from 'styled-components';
import {StyledInputProps} from './Input';

export const InputBlockWrapper = styled.div<StyledInputProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: ${({width}: StyledInputProps) => (width ? width : 'auto')};
`;

export const InputWrapper = styled.div<StyledInputProps>`
  display: flex;
  border: ${({borderColor, focus, error, disabled, inputHaveValue}: StyledInputProps) => {
    switch (true) {
      case borderColor && borderColor.length !== 0 && error && error!.length !== 0:
        return `1px solid ${theme?.colors.signalRed00}`;
      case borderColor && borderColor.length !== 0:
        return `1px solid ${borderColor}`;
      case disabled && inputHaveValue:
        return `1px solid ${theme?.colors.basic05}`;
      case disabled:
        return `1px solid ${theme?.colors.basic06}`;
      case focus:
        return `1px solid ${theme?.colors.basic03}`;
      case error && error.length !== 0:
        return `1px solid ${theme?.colors.signalRed00}`;
      default:
        return `1px solid ${theme?.colors.basic05}`;
    }
  }};
  border-radius: ${theme.roundedMedium};
  background-color: ${({disabled, inputHaveValue}) =>
    disabled && inputHaveValue ? theme.colors.basic07 : theme.colors.basic08};
  width: 100%;
  height: 46px;
  position: relative;
  transition: all 0.5s;
  &:hover {
    border: 1px solid ${theme?.colors.basic05};
    background-color: ${theme.colors.basic07};
  }
  & input {
    ${fontStyles.bodyNum}
    border: none;
    outline: none;
    padding: ${({withoutPadding}: StyledInputProps) =>
      withoutPadding ? '' : '24px 10px 8px 12px'};
    margin: 0;
    background-color: transparent;
    color: ${({disabled}: StyledInputProps) =>
      disabled ? theme.colors.basic04 : theme.colors.basic00};
    width: 100%;
    transition: padding 0.25s;
    position: relative;
    &[readonly],
    &[disabled] {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
  & input::placeholder {
    ${fontStyles.bodyNum}
    white-space: pre-line;
    position: absolute;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: ${({textColor}: StyledInputProps) =>
      textColor ? `${textColor}` : 'black'} !important;
  }
`;

export const ErrorText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1px;
  color: ${theme.colors.signalRed00};
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 16px;
  width: fit-content;
  background-color: transparent;
  border-radius: 0px 5px 5px 0px;
  z-index: 1;
  max-width: 70%;
  overflow-wrap: break-word;
`;

export const IconWrapper = styled.div`
  min-width: 16px;
  height: 18px;
  align-self: center;
  position: relative;
  z-index: 6;
  right: 16px;
  cursor: pointer;
`;

export const Label = styled.label<StyledInputProps>`
  ${({inputHaveValue, focus}) =>
    inputHaveValue || focus ? fontStyles.tinyR : fontStyles.bodyNum};
  color: ${({error, disabled}) =>
    error && error.length !== 0
      ? theme.colors.signalRed00
      : disabled
        ? theme.colors.basic04
        : theme.colors.basic03};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: calc(100% - 21px);
  transition: 0.2s all linear;
  position: absolute;
  top: ${({inputHaveValue, focus}) => (inputHaveValue || focus ? '6px' : '16px')};
  left: 12px;
`;
